import './App.css';
import Header from './components/Header';
import Services from './components/Services';
import Footer from './components/Footer';
import Packages from './components/Packages';
import Hero from './components/Hero';
import VirtualPhotobooth from './components/VirtualPhotobooth';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      {/* <About /> */}
      <Services />
      <div className='spacer-sm'></div>
      <VirtualPhotobooth />
      <Packages />
      <div className='spacer-lg'></div>
      {/* <Skills />
      <Contact /> */}
      <Footer />
    </div>
  );
}

export default App;
